module.exports = __webpack_public_path__ + "static/img/cloud-right_bottom.9e750e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-right_bottom.png
// module id = 661
// module chunks = 64